import React, { useRef } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import PopTestConfig from '../../components/Academics/Reports/PopTestConfig';
import { useReportView } from '../../DataStore/ReportViewContext';
import printContent from '../../util/araknerdlib';
import Pagination from '../../components/Common/Pagination';
import ReportFormat from '../../components/Report/ReportFormat';

const ReportViewerPage = () => {
  const {
    selectedReport,
    reportId,
    reports,
    loadingReports,
    notify,
    reportInfo,
    metaData,
    initials,
    setCurrentPage,
    appendingData,
    generateReports
  } = useReportView();

  const reportRef = useRef();

  const handlePrint = () => printContent(reportRef, 'Student Reports', false);
  const handleRefresh = () => generateReports(true, reportId);

  return (
    <>
      <PageContainer>
        <MainContent>
         <PageTitle
              title="Report Viewer"
              description={selectedReport?.title || 'Generate and view report cards for students.'}
              iconClass="fa fa-book-open"
              PageActions={() => (
                <>
                  <ActionDropdownItem
                    iconClass="fa fa-print text-success"
                    label="Print Reports"
                    onClick={handlePrint}
                  />
                  <ActionDropdownItem
                    iconClass="fa fa-sync text-primary"
                    label="Refresh"
                    onClick={handleRefresh}
                  />
                </>
              )}
              Pagination={
                metaData && (
                  <Pagination
                    metaData={metaData}
                    onPageChange={setCurrentPage}
                    loadMore
                    loading={loadingReports || appendingData}
                  />
                )
              }
              sticky
            />


          {!reportId && (
            <Notification
              type="info"
              message="Please select a report from the Reports page to load and view reports."
            />
          )}

          {notify}

          {Array.isArray(reports) && reports.length > 0 && (
            <div className="card mb-3">
              <div className="card-body" ref={reportRef}>
                {reports.map((report) => (
                  <ReportFormat
                    key={report.student_id}
                    student={report}
                    studentId={report.student_id}
                    reportInfo={reportInfo}
                    initials={initials}
                    totalStudents={metaData?.total}
                  />
                ))}
              </div>
            </div>
          )}

          {loadingReports && <ActivityLoader />}
        </MainContent>
      </PageContainer>

      <PopTestConfig />
    </>
  );
};

export default ReportViewerPage;
